let UTILS = require("../libs/utils.js");
var v7719;
var v7720;
module.exports = {
  id: "stalk",
  name: "Stalker",
  alias: "stalk",
  endStats: ["sid", "name", "score", "reward"],
  genID: "st",
  ambInd: 5,
  minPlayers: 2,
  fogD: 250,
  fogC: 1842204,
  skyCol: 1842204,
  lightCol: 855309,
  ambCol: 1513239,
  lives: 1,
  condition: [function (game) {
    var vLN01209 = 0;
    var vLN01210 = 0;
    for (var vLN01211 = 0; vLN01211 < game.players.list.length; ++vLN01211) {
      if (game.players.list[vLN01211].lives > 0) {
        if (game.players.list[vLN01211].team == 1) {
          vLN01209++;
        } else if (game.players.list[vLN01211].team == 2) {
          vLN01210++;
        }
      }
    }
    return vLN01209 >= 1 && vLN01210 >= 1;
  }],
  winCondition: function (game) {
    var vLN01212 = 0;
    for (var vLN01213 = 0; vLN01213 < game.players.list.length; ++vLN01213) {
      if (game.players.list[vLN01213].active && game.players.list[vLN01213].team == 2) {
        vLN01212++;
      }
    }
    if (vLN01212 > 0) {
      return 2;
    } else {
      return 1;
    }
  },
  waitTimers: [{
    time: 15000,
    msg: "picking stalker in ",
    trigger: function (p9147) {
      p9147.pickStalker();
    }
  }],
  onMelee: function (game, p9149, p9150, p9151) {
    var v7721 = p9149 && p9150 && p9149.team == 2;
    if (v7721) {
      if (p9151 && p9150) {
        p9150.send("scr", 0);
      }
      game.players.changeHealth(p9149, null, -40);
    }
    return v7721;
  },
  hideNames: true,
  noReward: true,
  noKick: true,
  teams: true,
  teamOptions: ["Living", "Stalker"],
  spdMlt: {
    1: 0.65
  },
  modelOverrides: {
    Stalker: {
      noCosmetics: true,
      skinColor: 0,
      shirtColor: 0,
      pantsColor: 0,
      shoeColor: 0,
      hairColor: 0,
      sleeveColor: 0,
      waistColor: 0
    }
  }
};